module.exports = __webpack_public_path__ + "img/bg-blur.c2016f05.jpg";